export default function LeaderMistakes() {
  const mistakes = [
    { icon: 'ri-user-line', title: 'Делают работу вместо сотрудников', desc: 'Руководитель продолжает выполнять задачи исполнителя, не доверяя команде. В итоге команда не растёт, а руководитель перегружен.' },
    { icon: 'ri-eye-line', title: 'Контролируют каждый шаг', desc: 'Микроменеджмент убивает инициативу. Сотрудники перестают думать самостоятельно и ждут указаний по каждому вопросу.' },
    { icon: 'ri-share-forward-line', title: 'Не умеют делегировать', desc: 'Боязнь потерять контроль или сомнение в компетенциях сотрудников приводят к тому, что все задачи замыкаются на руководителе.' },
    { icon: 'ri-chat-off-line', title: 'Избегают сложных разговоров', desc: 'Откладывание неприятных бесед о performance, конфликтах или увольнениях приводит к накоплению проблем и токсичной атмосфере.' },
    { icon: 'ri-feedback-line', title: 'Не дают обратную связь', desc: 'Сотрудники не знают, что делают хорошо, а что — плохо. Без обратной связи невозможно развитие и корректировка поведения.' },
    { icon: 'ri-emotion-line', title: 'Принимают решения эмоционально', desc: 'Импульсивные решения без анализа данных и последствий приводят к хаосу, демотивации и дорогим ошибкам.' },
    { icon: 'ri-seedling-line', title: 'Не развивают сотрудников', desc: 'Руководитель фокусируется только на задачах, забывая о росте людей. Сильные сотрудники уходят туда, где есть развитие.' },
    { icon: 'ri-calendar-2-line', title: 'Не умеют проводить встречи', desc: 'Совещания без повестки, целей и тайминга отнимают время и демотивируют команду. Люди воспринимают встречи как пустую трату времени.' },
    { icon: 'ri-battery-low-line', title: 'Не умеют мотивировать', desc: 'Используют только кнут или только пряник, не понимая индивидуальных потребностей сотрудников и истинных драйверов вовлечённости.' },
    { icon: 'ri-shield-flash-line', title: 'Не работают с сопротивлением', desc: 'При внедрении изменений игнорируют эмоции и страхи команды, что приводит к саботажу и провалу трансформаций.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Самые распространённые ошибки руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Большинство руководителей совершают эти ошибки неосознанно — просто потому, что их никто не учил управлять
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-red-200 transition-colors">
                  <i className={`${item.icon} text-lg text-red-600`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1">{item.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-xl p-6 md:p-8 text-center">
          <p className="text-teal-800 font-semibold text-base md:text-lg">
            Каждая из этих ошибок исправляется через системное обучение и практику. Именно поэтому тренинг для руководителей строится не на теории, а на отработке реальных управленческих ситуаций.
          </p>
        </div>
      </div>
    </section>
  );
}